module.exports = __webpack_public_path__ + "media/images/success/success_icon-1152171467f11ff4d708283fc11c1e68.png";